export const FORWARD_TITLE_MAX_LENGTH = 64;
export const FORWARD_DESCRIPTION_MAX_LENGTH = 1000;
